import type { Actor } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';

const useActorLabel = () => {
  const { t } = useTranslation('common', { keyPrefix: 'actor' });

  return (actor: Actor): string => {
    if (actor.kind === 'organization') {
      if (actor.firstName && actor.lastName) {
        return `${actor.firstName} ${actor.lastName}`;
      }
      return actor.email;
    }

    if (actor.kind === 'firm_employee') {
      const name = [actor.firstName, actor.lastName].filter(Boolean).join(' ').trim();
      const display = name || actor.email;
      return display ? `${display} (${t($ => $.firmEmployeeSuffix)})` : t($ => $.footprint);
    }

    if (actor.kind === 'api_key') {
      return actor.name;
    }

    if (actor.kind === 'footprint') {
      return t($ => $.footprint);
    }

    return t($ => $.user);
  };
};

export default useActorLabel;
